import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import routes from '../routes/routes'
import unitService from '../services/unit.service'
import unitApi, { UnitData } from '../apis/unit.api'
import categoryApi, { CategoryCreateRequest } from '../apis/category.api'
import ContentLayout from '../components/ContentLayout'
import ContentMain from '../components/ContentMain'
import Card from '../components/Card'
import CardButton from '../components/CardButton'
import Row from '../components/Row/Row'
import InputText from '../components/InputText'
import Select from '../components/Select'
import PageHeading from '../components/PageHeading'

interface CategoryCreateProps extends RouteComponentProps {}

interface CategoryCreateState {
  name: string
  unit: string
  units: UnitData[]
}

class CategoryCreate
  extends Component<CategoryCreateProps, CategoryCreateState> {
  constructor (props: CategoryCreateProps) {
    super(props)
    this.state = {
      name: '',
      unit: '',
      units: []
    }
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleCreateClick = this.handleCreateClick.bind(this)
  }

  get unitSelectOptions () {
    return unitService.selectOptions(this.state.units)
  }

  create () {
    const { name, unit } = this.state
    const payload: CategoryCreateRequest = {}
    if (name) payload.category = name
    if (unit) payload.type = Number(unit)
    categoryApi.create(payload, category => {
      if (!category) return
      this.props.history.push(routes.categories)
    })
  }

  handleInputChange (name: string, value: string) {
    if (name === 'name') this.setState({ name: value })
    if (name === 'unit') this.setState({ unit: value })
  }

  handleCreateClick () {
    this.create()
  }

  listUnits () {
    unitApi.list(units => {
      if (!units) return
      this.setState({ units })
    })
  }

  componentDidMount () {
    this.listUnits()
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="oneThird">
          <Card>
            <PageHeading
              text={i18n("Create Category")}
              doc='categories-create-category' />
            <Row column={1}>
              <InputText
                name="name"
                value={this.state.name}
                label={i18n("Category")}
                onChange={this.handleInputChange} />
              <Select
                name="unit"
                value={this.state.unit}
                options={this.unitSelectOptions}
                label={i18n("Type")}
                onChange={this.handleInputChange} />
            </Row>
            <CardButton
              proceedText={i18n("Create")}
              cancelText={i18n("Cancel")}
              onProceedClick={this.handleCreateClick} />
          </Card>
        </ContentMain>
      </ContentLayout>
    )
  }
}

export default withRouter(CategoryCreate)
